/* 🤖 this file was generated by svg-to-ts */
export const iconNewWindow16: {
  name: 'new_window_16';
  data: string;
} = {
  name: 'new_window_16',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12.778 0C14.555 0 16 1.346 16 3v6c0 1.654-1.445 3-3.222 3H12v1c0 1.654-1.445 3-3.222 3H3.222C1.445 16 0 14.654 0 13V7c0-1.654 1.445-3 3.222-3H4V3c0-1.654 1.445-3 3.222-3h5.556ZM4 6h-.778C2.549 6 2 6.448 2 7v6c0 .552.549 1 1.222 1h5.556C9.452 14 10 13.552 10 13v-1H7.222C5.445 12 4 10.654 4 9V6Zm8.778-4H7.222C6.548 2 6 2.448 6 3v6c0 .552.548 1 1.222 1h5.556C13.451 10 14 9.552 14 9V3c0-.552-.549-1-1.222-1ZM10 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V7H8a1 1 0 1 1 0-2h1V4a1 1 0 0 1 1-1Z"/></svg>`,
};
